import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {ResponseModel} from '../../../DataModels/response-model';
import {PagerStateService} from '../../../Services/pager-state.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbpaginationConfigService} from '../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-timesheet-approval-list',
  templateUrl: './timesheet-approval-list.component.html',
  styleUrls: ['./timesheet-approval-list.component.css'],
  standalone: false
})
export class TimesheetApprovalListComponent extends ListPageBase implements OnInit {
  vm: any = {
    title: $localize`:Timesheet Approval@@timesheetApproval:Timesheet Approval`,
    list: [],
    Preferences: [],
    permissions: [],
    listInitiated: false,
    formRoute: '/timesheet/timesheet-approval-form',
  };

  isLoaded = false;

  selectedIds: Set<string> = new Set();
  bulkActionDisabled = false;
  selectedApproverId = '';

  // Status filter dropdown: 'all' | 'unapproved' | 'approved' | 'submitted'
  statusFilter = 'unapproved';
  statusFilterOptions = [
    // { value: 'all',       label: $localize`:All@@all:All` },
    {value: 'unapproved', label: $localize`:Unapproved@@unapproved:Unapproved`},
    {value: 'approved', label: $localize`:ApprovedPendingGusto@@approvedPendingGusto:Approved Pending Gusto`},
    {value: 'submitted', label: $localize`:SubmittedToGusto@@submittedToGusto:Submitted to Gusto`},
  ];

  constructor(
    private localStorage: StorageService,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: BsToastService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle(this.vm.title);
    this.vm.list = [];
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));


    this.tableDataService.getApiListData('sys_user?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: ResponseModel) => {
        this.vm.approvers = result.Data ?? [];
      },
      error: (err) => console.error(err),
    });

    this.loadData();
  }

  protected fetchPage(): void {
    this.loadData();
  }

  loadData() {
    let endpoint: string;
    let paramString = '?pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0) + '&pageSize=' + this.pageSize;

    if (this.statusFilter === 'all') {
      endpoint = 'pr_timesheet';
      paramString += '&all=true';
    } else if (this.statusFilter === 'approved') {
      endpoint = 'pr_timesheet';
      paramString += '&status=approved&pending_gusto=true';
    } else if (this.statusFilter === 'submitted') {
      endpoint = 'pr_timesheet';
      paramString += '&submitted_to_gusto=true';
    } else {
      endpoint = 'pr_timesheet/pending-approval';
      if (this.statusFilter === 'unapproved') {
        paramString += '&status=unapproved';
      } //else if (this.statusFilter === 'submitted') {
      //   paramString += '&submitted_to_gusto=true';
      // }
    }

    if (this.selectedApproverId) {
      paramString += '&approver_id=' + this.selectedApproverId;
    }
    this.tableDataService.getApiListData(endpoint, paramString).subscribe({
      next: (result: ResponseModel) => {
        console.log('timesheet-approval-list loadData result:', result);
        this.vm.list = result.Data ?? (result as any).data ?? [];
        this.totalRecords = result.totalRecords ?? 0;
        this.selectedIds.clear();
        this.paginate(false);
        this.vm.listInitiated = true;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast($localize`:Error loading approval queue@@errorLoadingApprovalQueue:Error loading approval queue`);
      },
    });
  }

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'submitted':
        return 'bg-info text-dark';
      case 'returned':
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  }

  gustoBadgeClass(row: any): string {
    if (row.gusto_timesheet_id) {
      return 'bg-success';
    }
    if (row.status === 'approved') {
      return 'bg-warning text-dark';
    }
    return '';
  }

  gustoBadgeLabel(row: any): string {
    if (row.gusto_timesheet_id) {
      return 'Pushed';
    }
    if (row.status === 'approved') {
      return 'Pending';
    }
    return '';
  }

  onNavigate(id: string) {
    this.router.navigate([this.vm.formRoute], {queryParams: {id}}).then();
  }

  // Checkbox selection
  isSelected(id: string): boolean {
    return this.selectedIds.has(id);
  }

  toggleSelect(id: string) {
    if (this.selectedIds.has(id)) {
      this.selectedIds.delete(id);
    } else {
      this.selectedIds.add(id);
    }
  }

  get allSelected(): boolean {
    return this.vm.list.length > 0 && this.vm.list.every((r: any) => this.selectedIds.has(r.id));
  }

  toggleSelectAll() {
    if (this.allSelected) {
      this.selectedIds.clear();
    } else {
      this.vm.list.forEach((r: any) => this.selectedIds.add(r.id));
    }
  }

  get selectedCount(): number {
    return this.selectedIds.size;
  }

  // Bulk actions
  bulkApprove() {
    if (this.selectedIds.size === 0 || this.bulkActionDisabled) {
      return;
    }
    this.bulkActionDisabled = true;
    const ids = Array.from(this.selectedIds);
    this.tableDataService.put('pr_timesheet/bulk-approve', '', ids).subscribe({
      next: (result: any) => {
        this.notification.showSuccessToast($localize`:Approved@@approved:Approved` + ' ' + (result?.approved ?? ids.length));
        this.bulkActionDisabled = false;
        this.loadData();
      },
      error: (err) => {
        console.error(err);
        this.bulkActionDisabled = false;
        this.notification.showErrorToast($localize`:Error approving timesheets@@errorApprovingTimesheets:Error approving timesheets`);
      },
    });
  }

  bulkReturn() {
    if (this.selectedIds.size === 0 || this.bulkActionDisabled) {
      return;
    }
    this.bulkActionDisabled = true;
    const ids = Array.from(this.selectedIds);
    this.tableDataService.put('pr_timesheet/bulk-return', '', ids).subscribe({
      next: (result: any) => {
        this.notification.showSuccessToast($localize`:Returned@@returned:Returned` + ' ' + (result?.returned ?? ids.length));
        this.bulkActionDisabled = false;
        this.loadData();
      },
      error: (err) => {
        console.error(err);
        this.bulkActionDisabled = false;
        this.notification.showErrorToast($localize`:Error returning timesheets@@errorReturningTimesheets:Error returning timesheets`);
      },
    });
  }

  onApproverChange() {
    this.page = 1;
    this.loadData();
  }

  onStatusFilterChange() {
    this.page = 1;
    this.selectedIds.clear();
    this.loadData();
  }

  // Only approved rows without a gusto_timesheet_id are eligible for Push to Gusto
  get eligibleForGusto(): any[] {
    return this.vm.list.filter((r: any) => r.status === 'approved' && !r.gusto_timesheet_id);
  }

  get allEligibleSelected(): boolean {
    const eligible = this.eligibleForGusto;
    return eligible.length > 0 && eligible.every((r: any) => this.selectedIds.has(r.id));
  }

  selectAllApproved() {
    if (this.allEligibleSelected) {
      this.eligibleForGusto.forEach((r: any) => this.selectedIds.delete(r.id));
    } else {
      this.eligibleForGusto.forEach((r: any) => this.selectedIds.add(r.id));
    }
  }

  get pushToGustoEnabled(): boolean {
    // Only enable when at least one selected row is eligible (approved + no gusto id)
    return Array.from(this.selectedIds).some(id =>
      this.vm.list.find((r: any) => r.id === id && r.status === 'approved' && !r.gusto_timesheet_id)
    );
  }

  // Return is disabled if any selected row has already been pushed to Gusto
  get returnDisabled(): boolean {
    if (this.selectedIds.size === 0 || this.bulkActionDisabled) {
      return true;
    }
    return Array.from(this.selectedIds).some(id =>
      this.vm.list.find((r: any) => r.id === id && r.gusto_timesheet_id)
    );
  }

  // Approve is disabled if any selected row has already been pushed to Gusto
  get approveDisabled(): boolean {
    if (this.selectedIds.size === 0 || this.bulkActionDisabled) {
      return true;
    }
    return Array.from(this.selectedIds).some(id =>
      this.vm.list.find((r: any) => r.id === id && r.gusto_timesheet_id)
    );
  }

  bulkPushToGusto() {
    if (!this.pushToGustoEnabled || this.bulkActionDisabled) {
      return;
    }
    this.bulkActionDisabled = true;
    const ids = Array.from(this.selectedIds).filter(id =>
      this.vm.list.find((r: any) => r.id === id && r.status === 'approved' && !r.gusto_timesheet_id)
    );
    this.tableDataService.post('Gusto/bulk-push-timesheets', ids).subscribe({
      next: (result: any) => {
        this.notification.showSuccessToast($localize`:PushedToGusto@@pushedToGusto:Pushed to Gusto` + ' ' + (result?.pushed ?? ids.length));
        this.bulkActionDisabled = false;
        this.loadData();
      },
      error: (err) => {
        console.error(err);
        this.bulkActionDisabled = false;
        this.notification.showErrorToast($localize`:ErrorPushingToGusto@@errorPushingToGusto:Error pushing to Gusto`);
      },
    });
  }

  serverSearch(value: any) {
    this.page = 1;
    this.loadData();
  }

  clearServerSearch(value: any) {
    this.page = 1;
    this.loadData();
  }
}
